import React from 'react';
import useCondition from '../../../useCondition';
import Header from '../../Header';
import Footer from '../Footer';
import {useSalesforceContactRecordTypesQuery} from 'api';
import ContactField from './ContactField';
import ContactOwnerField from './ContactOwnerField';

const SalesforceContactFilter = () => {
  const {condition, setCondition} = useCondition();

  const {data: {salesforceContactRecordTypes = []} = {}} =
    useSalesforceContactRecordTypesQuery();

  const updateCondition = (params: Parameters<typeof setCondition>[0]) => {
    const searchCondition = {...condition, ...params};
    const hasSalesforceContact = Boolean(
      searchCondition.salesforceContactRecordTypeId ||
        searchCondition.salesforceContactOwnerIds?.length > 0 ||
        searchCondition.salesforceContactSearchConditions?.length > 0,
    );
    setCondition({
      ...params,
      hasSalesforceContact,
    });
  };

  return (
    <>
      <Header title="Salesforce取引先責任者" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div className="text-c-base font-bold">レコードタイプ</div>
            <select
              className="form-select border-c-border rounded text-base w-full"
              onChange={(e) =>
                updateCondition({
                  salesforceContactRecordTypeId: e.target.value,
                  salesforceContactSearchConditions: [],
                })
              }
              value={condition?.salesforceContactRecordTypeId}>
              <option value="" />
              {salesforceContactRecordTypes.map((recordType) => (
                <option value={recordType.id} key={recordType.id}>
                  {recordType.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex flex-col gap-2">
            <div className="text-c-base font-bold">所有者</div>
            <ContactOwnerField
              onChange={(ownerIds: string[]) =>
                updateCondition({
                  salesforceContactOwnerIds: ownerIds,
                })
              }
              values={condition?.salesforceContactOwnerIds || []}
            />
          </div>
          <div className="flex flex-col gap-2">
            <div className="text-c-base font-bold">条件項目</div>
            {condition.salesforceContactSearchConditions?.map(
              (searchCondition, index) => (
                <ContactField
                  key={searchCondition.id}
                  searchCondition={searchCondition}
                  setSearchCondition={(searchCondition) => {
                    const searchConditions = [
                      ...condition.salesforceContactSearchConditions,
                    ];
                    searchConditions[index] = searchCondition;
                    updateCondition({
                      salesforceContactSearchConditions: searchConditions,
                    });
                  }}
                  onDelete={() => {
                    const searchConditions = [
                      ...condition.salesforceContactSearchConditions,
                    ];
                    searchConditions.splice(index, 1);
                    updateCondition({
                      salesforceContactSearchConditions: searchConditions,
                    });
                  }}
                />
              ),
            )}
            <button
              className="cursor-pointer w-32 h-8 flex items-center justify-center rounded bg-white border border-c-border text-light disabled:bg-c-bg disabled:text-c-light disabled:cursor-not-allowed"
              disabled={!condition.salesforceContactRecordTypeId}
              onClick={() =>
                updateCondition({
                  salesforceContactSearchConditions: [
                    ...(condition.salesforceContactSearchConditions || []),
                    {},
                  ],
                })
              }>
              + 条件を追加
            </button>
          </div>
        </div>
      </div>
      <Footer
        onClear={() =>
          setCondition({
            hasSalesforceContact: false,
            salesforceContactRecordTypeId: '',
            salesforceContactOwnerIds: [],
            salesforceContactSearchConditions: [],
          })
        }
      />
    </>
  );
};

export default SalesforceContactFilter;
